import { IMAGE_FAMILY } from "./register.service";

export const name = 'startBackground';
export default function startBackground(
  $log,
  $compile,
  registerService,
  $mdMedia,
  $location
) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  const directive = {
    restrict: 'EA',
    scope: {
      bu: '@',
      icon: '@'
    },
    link: startBackgroundLink,
  };

  return directive;


  //////////////////////
  // Private functions

  function startBackgroundLink(scope, element, attrs, controllers) {
    let previousWatchResult = {size : -1, is3d: false};
    scope.$watch(() => {
      let bu = attrs.bu;
      if(!bu){
        bu = $location.search().bu;
      }

      let is3d = (bu === '3D');

      let size;
      if ($mdMedia('xs')) {
        size = 0;
      }
      else if ($mdMedia('gt-md')) {
        size = 2;
      } else {
        size = 1;
      }

      return {
        is3d,
        size,
      };
    }, watchResult => {
      if(watchResult.size > previousWatchResult.size || watchResult.is3d !== previousWatchResult.is3d || element.css('background-image') === '') {
        previousWatchResult = watchResult;
        if(watchResult.is3d) {
          // Add a marker class for automated testing
          element.removeClass('background-general');
          element.addClass('background-3d');

          element.css({
             'background-image': 'url(' + registerService.getBackgroundImage(IMAGE_FAMILY.ThreeD) + ')',
             'background-repeat': 'no-repeat',
             'background-size': 'cover',
             'background-position': registerService.getPosition(IMAGE_FAMILY.ThreeD),
           });
        } else {
          // Add a marker class for automated testing
          element.removeClass('background-3d');
          element.addClass('background-general');

          element.css({
            'background-image': 'url(' + registerService.getBackgroundImage(IMAGE_FAMILY.general) + ')',
            'background-repeat': 'no-repeat',
            'background-size': 'cover',
            'background-position': registerService.getPosition(IMAGE_FAMILY.general),
          });
        }
      }
      // Need to do object equality when returning an object from $watch.
      // See https://stackoverflow.com/a/19455564/277307
    }, true);
  }
}



// WEBPACK FOOTER //
// ./components/start-background/start-background.directive.js